import React, { useState, useEffect } from 'react';

function LapHk() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [end_date, setEndDate] = useState(formatDate(addDays(new Date(), 0)));
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function formatDate(date) {
    return date.toISOString().split('T')[0];
  }

  const formatNumber = (value) =>
    isNaN(value) ? value : new Intl.NumberFormat('id-ID').format(Number(value));

  const numericKeys = [
    'HK_BON',
    'HK_CUSTOMER',
    'HK_AWAL',
    'HK_LAKA',
    'HK_PERLENGKAPAN',
    'HK_TOTAL',
    'TAB_SALDO',
    'SISA_KURANG',
    'KELEBIHAN',
  ];

  const columns = [
    'SOPIR',
    'JNS_KENDARAAN',
    'AREA',
    'HK_BON',
    'HK_CUSTOMER',
    'HK_AWAL',
    'HK_LAKA',
    'HK_PERLENGKAPAN',
    'HK_TOTAL',
    'TAB_SALDO',
    'SISA_KURANG',
    'KELEBIHAN',
  ];

  const fetchLapPasangData = async () => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/laporan.php?caller=lap_hk&schema=${schema}&end_date=${end_date}`;
      const response = await fetch(url);
      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Data tidak valid');
      }
    } catch (error) {
      alert('Gagal memuat data');
    }
  };

  useEffect(() => {
    fetchLapPasangData();
  }, [end_date]);

  useEffect(() => {
    let filtered = LapPasangData.filter((item) =>
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key] ?? '').toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [filters, LapPasangData]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  const getSortIcon = (key) =>
    sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '';

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff' }}>
      <h2 style={{ color: '#9B459C' }}>Laporan Hutang Karyawan</h2>
      <div style={{ marginBottom: '10px' }}>
        <label>Periode s.d: </label>
        <input
          type="date"
          value={end_date}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        />
        <button onClick={fetchLapPasangData} style={{ marginLeft: '10px', padding: '5px 10px' }}>
          Refresh
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  onClick={() => handleSort(col)}
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    backgroundColor: '#f2f2f2',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                  {col.replace('HK_', '').replace('_', ' ')} {getSortIcon(col)}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={`filter-${col}`} style={{ border: '1px solid #ccc', padding: '4px' }}>
                  <input
                    type="text"
                    placeholder="Filter..."
                    style={{
                      width: '90%',
                      padding: '4px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                    }}
                    onChange={(e) => setFilters({ ...filters, [col]: e.target.value })}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  {columns.map((key) => (
                    <td
                      key={key}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        textAlign: numericKeys.includes(key) ? 'right' : 'left',
                      }}
                    >
                      {numericKeys.includes(key) ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '10px' }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LapHk;
